import OrderService from 'src/common/api/order.service';

export async function registerKioskPayment(context, payload) {
  const response = await OrderService.post(payload);
  return response;
}

export async function initPosPayment(context, payload) {
  await OrderService.initPosPayment(payload);
}

export async function getPosPoiStatus(context, { terminalId }) {
  const response = await OrderService.getPosPoiStatus({ terminalId });
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function getPosPaymentStatus(context, { invoiceId }) {
  return new Promise((resolve, reject) => {
    let timeout;
    const intervalId = setInterval(async () => {
      const response = await OrderService.getPosPaymentStatus({ invoiceId });
      if (response.status === 200) {
        const { receipt } = response.data;
        if (receipt.data.posStatus === 'success') {
          clearTimeout(timeout);
          clearInterval(intervalId);
          resolve();
        }

        if (receipt.data.posError) {
          clearTimeout(timeout);
          clearInterval(intervalId);
          if (receipt.data.posError === 'UNAVAILABLEDEVICE') {
            reject(new Error('errorPoiUnavailable'));
          }

          if (
            receipt.data.posError === 'REFUSAL'
            || receipt.data.posError === 'NOTALLOWED'
          ) {
            reject(new Error('errorPoiRefusal'));
          }

          if (receipt.data.posError === 'BUSY') {
            reject(new Error('errorPoiBusy'));
          }

          if (
            receipt.data.posError === 'ABORTED'
            || receipt.data.posError === 'CANCEL'
          ) {
            reject(new Error('errorTransactionAborted'));
          }

          reject(new Error('errorPoiError'));
        }
      }
      else {
        clearTimeout(timeout);
        clearInterval(intervalId);
        reject(new Error('errorGettingPoiStatus'));
      }
    }, 5000);

    timeout = setTimeout(() => {
      clearTimeout(timeout);
      clearInterval(intervalId);
      reject(new Error('errorPoiTimedOut'));
    }, 120000);
  });
}
